import { render, staticRenderFns } from "./MouseSetting.vue?vue&type=template&id=58e52fa1&scoped=true"
import script from "./MouseSetting.vue?vue&type=script&lang=js"
export * from "./MouseSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e52fa1",
  null
  
)

export default component.exports